import utils from 'helpers/utils';
import {
    CREATE_ACCESS_POINTS_ACCESS_METHOD,
    CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN,
    CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_FAILURE,
    CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_SUCCESS,
    CREATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
    DELETE_ACCESS_POINTS_ACCESS_METHOD,
    DELETE_ACCESS_POINTS_ACCESS_METHOD_FAILURE,
    DELETE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
    FETCH_ACCESS_POINTS_ACCESS_METHODS,
    FETCH_ACCESS_POINTS_ACCESS_METHODS_FAILURE,
    FETCH_ACCESS_POINTS_ACCESS_METHODS_SUCCESS,
    UPDATE_ACCESS_POINTS_ACCESS_METHOD,
    UPDATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE,
    UPDATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
} from 'store/actions/types';
import reducerHelper from 'helpers/reducers';

const initialState = {
    data: {},
    loading: false,
    offset: 0,
    size: 24,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ACCESS_POINTS_ACCESS_METHODS:
        case DELETE_ACCESS_POINTS_ACCESS_METHOD:
        case CREATE_ACCESS_POINTS_ACCESS_METHOD:
        case UPDATE_ACCESS_POINTS_ACCESS_METHOD:
        case CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN:
            return Object.assign({}, state, {
                loading: true,
            });
        case CREATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.results,
                    { [action.response.id]: action.response }
                ),
                loading: false,
            });
        case FETCH_ACCESS_POINTS_ACCESS_METHODS_SUCCESS:
            return Object.assign({}, state, action.response, {
                data: utils.mapToObject(action.response.results, (obj) => {
                    return obj.id;
                }),
                loading: false,
            });
        case UPDATE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS:
            return Object({}, state, {
                loading: false,
                data: Object.assign({}, state.results, {
                    [action.response.id]: action.response.response,
                }),
            });
        case DELETE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS:
            const { id } = action.response;

            const newResults = reducerHelper.removeItemFromObject(state.data, id);

            return Object.assign({}, state, {
                data: newResults,
                loading: false,
                total: state.total - 1,
            });
        case CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
            });
        case FETCH_ACCESS_POINTS_ACCESS_METHODS_FAILURE:
        case UPDATE_ACCESS_POINTS_ACCESS_METHOD_FAILURE:
        case CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_FAILURE:
        case DELETE_ACCESS_POINTS_ACCESS_METHOD_FAILURE:
            return Object.assign({}, state, {
                error: action.error,
                loading: false,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/accessPointsAccessMethodReducer.js